import { render, staticRenderFns } from "./MasterDataTable.vue?vue&type=template&id=a21dc47a"
import script from "./MasterDataTable.vue?vue&type=script&lang=js"
export * from "./MasterDataTable.vue?vue&type=script&lang=js"
import style0 from "./MasterDataTable.vue?vue&type=style&index=0&id=a21dc47a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports